// import { ProductComponent } from '@app/forms/product/product.component';
import { FormCategoryComponent } from '@app/forms/category/category.component';
import { AttributeComponent } from './../../forms/attribute/attribute.component';
import { AttributeSetComponent } from './../../forms/attribute-set/attribute-set.component';
import { AttributeGroupComponent } from './../../forms/attribute-group/attribute-group.component';
import { Validators } from '@angular/forms';
import { BrandComponent } from '@app/forms/brand/brand.component';
import { CurrencyComponent } from '@app/forms/currency/currency.component';
import { LanguageComponent } from '@app/forms/language/language.component';
import { ManufacturerComponent } from '@app/forms/manufacturer/manufacturer.component';
import { TagComponent } from '@app/forms/tag/tag.component';
import { RelationshipComponent } from '@app/forms/relationship/relationship.component';
// import { ExportProfileComponent } from '@app/forms/export-profile/export-profile.component';
// import { SchedulerComponent } from '@app/forms/scheduler/scheduler.component';
import { DisplayGroupComponent } from '@app/forms/display-group/display-group.component';
import { ProductStatusComponent } from '@app/forms/product-status/product-status.component';

export class FormComponentModel {
  static getControls(model: string, mode: string): { [key: string]: any } {
    if (model === 'language') {
      return LanguageComponent.controls(mode);
    } else if (model === 'brand') {
      return BrandComponent.controls(mode);
    } else if (model === 'manufacturer') {
      return ManufacturerComponent.controls(mode);
    } else if (model === 'currency') {
      return CurrencyComponent.controls(mode);
    } else if (model === 'attribute-group') {
      return AttributeGroupComponent.controls(mode);
    } else if (model === 'attribute-set') {
      return AttributeSetComponent.controls(mode);
    } else if (model === 'attribute') {
      return AttributeComponent.controls(mode);
    } else if (model === 'product-status') {
      return ProductStatusComponent.controls(mode);
    } else if (model === 'tag') {
      return TagComponent.controls(mode);
    } else if (model === 'relationship') {
      return RelationshipComponent.controls(mode);
    } /*else if (model === 'export-profile') {
      return ExportProfileComponent.controls(mode);
    } else if (model === 'scheduler') {
      return SchedulerComponent.controls(mode);
    } */ else if (model === 'category') {
      return FormCategoryComponent.controls(mode);
    } /*else if (model === 'product') {
      return ProductComponent.controls(mode);
    } */ else if (model === 'display-properties') {
      return DisplayGroupComponent.controls(mode);
    } else {
      return {
        '@odata.context': [null, [Validators.required]],
      };
    }
  }
}
